import { useState, useEffect } from "react";

const navLinks = [
  { label: "About", href: "#about" },
  { label: "Highlights", href: "#highlights" },
  { label: "Streams", href: "#streams" },
  { label: "Socials", href: "#socials" },
  { label: "Tetris", href: "#tetris" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#07070f]/95 backdrop-blur-md border-b border-[#e879f9]/20"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <a href="#hero" onClick={() => handleNavClick("#hero")} className="flex items-center gap-3 cursor-pointer">
          <div className="w-10 h-10 flex items-center justify-center">
            <img
              src="https://public.readdy.ai/ai/img_res/8d3920c3-79a6-4087-8e00-e450527d6780.png"
              alt="Aidan Barrett Logo"
              className="w-10 h-10 object-contain rounded-full border border-[#e879f9]/40"
            />
          </div>
          <span className="font-orbitron text-sm font-bold tracking-widest neon-text-fuchsia uppercase">
            AidanGG
          </span>
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="font-rajdhani text-sm font-semibold uppercase tracking-widest text-slate-300 hover:text-[#e879f9] transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* CTA Button */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNavClick("#contact"); }}
            className="btn-neon font-orbitron text-xs font-bold uppercase tracking-widest px-5 py-2 rounded-md border border-[#e879f9] text-[#e879f9] hover:bg-[#e879f9]/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get In Touch
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-[#e879f9] cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#07070f]/98 border-b border-[#e879f9]/20 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="font-rajdhani text-base font-semibold uppercase tracking-widest text-slate-300 hover:text-[#e879f9] transition-colors text-left cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
